module.exports = "<span class=\"kl-badge kl-badge--{type} kl-badge--{circle ? 'number' : ''}\">{text}</span>"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/widget/KLBadge/index.html
// module id = 526
// module chunks = 0